/* eslint-disable camelcase */

export default class Dimension {
  constructor ({ dim_key, description, dimension, selected, dim_value }) {
    this.id = dim_value
    this.value = description
    this.type = dimension
    this.selected = selected
    this.key = dim_key
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/Dimension.js